import ScrollableContent from "./ScrollableContent";

export default ScrollableContent;
